import { getEnv } from '../helpers/getEnv';

export const useJoinUsUrl = (redirectPath?: string): string => {
  const joinUsUrl = new URL('/join-us/', getEnv.CANONICAL_DOMAIN());

  if (redirectPath) {
    joinUsUrl.searchParams.append('redirect_path', redirectPath);
  }

  return joinUsUrl.href;
};
